/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowExpandIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M22.474 15.438 30.928 7h-5.386c-.877 0-1.503-.625-1.503-1.5 0-.812.626-1.5 1.503-1.5h8.955C35.374 4 36 4.688 36 5.5v9c0 .875-.626 1.5-1.503 1.5-.814 0-1.503-.625-1.503-1.5V9.125l-8.454 8.438a1.373 1.373 0 0 1-2.066 0c-.627-.563-.627-1.5 0-2.125m-4.885 9.125L9.072 33h5.449c.814 0 1.502.688 1.502 1.5 0 .875-.688 1.5-1.502 1.5H5.502C4.626 36 4 35.375 4 34.5v-9c0-.812.626-1.5 1.503-1.5.814 0 1.503.688 1.503 1.5v5.438L15.46 22.5c.563-.625 1.503-.625 2.129 0a1.47 1.47 0 0 1 0 2.063"/>}
        </IconWrapper>);
}
